<template>
  <div
    v-if="shouldRender"
    :class="[
      'landing-incentive-badge',
      `landing-incentive-badge--${incentiveTypeClass}`,
    ]"
  >
    <div class="landing-incentive-badge__image-wrap">
      <img
        :src="promoBadgeImage"
        alt=""
        class="landing-incentive-badge__image"
      />
    </div>

    <p
      class="landing-incentive-badge__copy"
      v-html="incentiveCopy"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { INCENTIVE_TYPES } from '@shared/data/models/corporate.js'
import matImage from '@us/app/assets/img/mat.png'
import fitbitImage from '@us/app/assets/img/fitbit.png'

const props = defineProps({
  incentive: {
    type: Object,
    default: null,
  },
})

const supportedIncentiveTypes = [
  INCENTIVE_TYPES.exercise_mat,
  INCENTIVE_TYPES.fitbit,
]

const incentiveType = computed(() => props.incentive?.incentiveType || '')
const incentiveTypeClass = computed(() =>
  incentiveType.value === INCENTIVE_TYPES.fitbit ? 'fitbit' : 'exercise-mat',
)
const incentiveCopy = computed(() => props.incentive?.bannerDescription || '')
const shouldRender = computed(
  () =>
    supportedIncentiveTypes.includes(incentiveType.value) &&
    incentiveCopy.value.length > 0,
)

const promoBadgeImage = computed(() =>
  incentiveType.value === INCENTIVE_TYPES.fitbit ? fitbitImage : matImage,
)
</script>

<style lang="scss" scoped>
.landing-incentive-badge {
  @include flex-container(row, flex-start, 0, stretch);
  position: absolute;
  left: 50%;
  bottom: 14px;
  width: 90%;
  min-height: 56px;
  transform: translateX(-50%);
  border-radius: 12px;
  border: 1px solid #fff;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  @include media-up(md) {
    left: $kds-space-8x;
    bottom: 20px;
    width: 70%;
    max-width: 370px;
    min-height: 68px;
    transform: none;
    border-radius: 12px;
  }

  @include media-between(md, tablet-max) {
    left: 50%;
    transform: translateX(-50%);
  }

  &__image-wrap {
    @include flex-container(row, center, 0, center);
    flex: 0 0 32%;
  }

  &__image {
    width: auto;
    height: 44px;
    transform: scale(2) rotate(-7deg) translateX(-8px);

    @include media-up(md) {
      height: 54px;
    }
  }

  &__copy {
    margin: 0;
    padding: 10px $kds-space-1x;
    color: $kds-color-text-primary;
    @include kds-typography-ui-subtle-large;
    font-size: 1rem;

    :deep(strong),
    :deep(b) {
      font-weight: $kds-typography-font-weight-bold;
    }

    @include media-up(md) {
      padding: $kds-space-1_5x $kds-space-2_5x;
    }
  }

  &--fitbit {
    .landing-incentive-badge__image {
      height: 34px;
      transform: none;

      @include media-up(md) {
        height: 44px;
      }
    }
  }
}
</style>
